import { useForm } from "react-hook-form";
import { BoxInner, ErrMsg } from "../../../style/contents/backup/backup";
import { fetchUpdatePasswordUser } from "../../../api/auth";

interface ModalProps {
  closedHandler: () => void;
}

const PasswordModify = ({ closedHandler }: ModalProps) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm();

  // 비밀번호 수정 제출 처리
  const onSubmit = async (data: any) => {
    // 비밀번호와 확인 비밀번호가 일치하는지 먼저 확인
    if (data.password !== data.confirmPassword) {
      alert("비밀번호와 비밀번호 확인이 일치하지 않습니다.");
      return;
    }

    try {
      // 비밀번호 업데이트 API 호출
      const response = await fetchUpdatePasswordUser(data.password);

      if (response.status === 204) {
        alert("비밀번호가 이전과 동일합니다.");
      } else {
        console.log("비밀번호 변경 성공:", response);
        alert("비밀번호가 성공적으로 변경되었습니다.");
      }

      // 폼 리셋
      reset();
      closedHandler(); // 모달 닫기
    } catch (error) {
      console.error("비밀번호 변경 실패:", error);
      alert("비밀번호 변경에 실패했습니다. 다시 시도해주세요.");
    }
  };

  return (
    <BoxInner>
      <div className="modal-header">
        <p>비밀번호 변경</p>
        <button
          onClick={closedHandler}
          className="closed-modal-btn"
          style={{ cursor: "pointer" }}
        >
          <img src="/assets/Close_Icons_UIA.svg" alt="" />
        </button>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="info">
          <p>비밀번호 변경</p>
        </div>
        <table>
          <tbody>
            <tr>
              <th>
                비밀번호<b>*</b>
              </th>
              <td>
                <input
                  type="password"
                  {...register("password", {
                    required: "비밀번호를 입력해주세요",
                    pattern: {
                      value:
                        /^(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+={}:;"'<>,.?/-]).{10,}$/,
                      message:
                        "비밀번호는 최소 10자 이상, 소문자, 숫자, 특수기호가 포함되어야 합니다.",
                    },
                  })}
                />
              </td>
            </tr>
            <tr>
              <th>
                비밀번호 확인<b>*</b>
              </th>
              <td>
                <input
                  type="password"
                  {...register("confirmPassword", {
                    required: "비밀번호 확인을 입력해주세요",
                    validate: (value) =>
                      value === watch("password") ||
                      "비밀번호가 일치하지 않습니다",
                  })}
                />
              </td>
            </tr>
          </tbody>
        </table>
        {errors.password && (
          <ErrMsg>
            {typeof errors.password.message === "string"
              ? errors.password.message
              : ""}
          </ErrMsg>
        )}
        {!errors.password && errors.confirmPassword && (
          <ErrMsg>
            {typeof errors.confirmPassword.message === "string"
              ? errors.confirmPassword.message
              : ""}
          </ErrMsg>
        )}

        <div className="btn-box">
          <button type="submit" className="regist">
            수정
          </button>
          <button type="button" className="cancel" onClick={closedHandler}>
            취소
          </button>
        </div>
      </form>
    </BoxInner>
  );
};

export default PasswordModify;
